export default __webpack_public_path__ + "static/media/hero-demo.1879d236.gif";